import actions from './actions'
import userActions from '../user/actions'

const initialState = {
  loading: false,
  modalVisible: false,
  bookaMeetingModal: false,
  passwordStrength: '',
  progressLogColor: '',
  password: '',
  passwordPercentage: 0,
  preferredCommunications: [],
  brandProducts: {},
  payconstructProducts: {},
  paymeroProducts: {},
  preQualification: {},
  overAllKycStatus: '',
  selectedCompanyInformation: {
    tradingName: '',
    companyNumber: '',
    countryOfIncorportation: '',
    registeredCompanyName: '',
    companyType: '',
    websiteAddress: [],
    buildingNumber: '',
    city: '',
    postCode: '',
    street: '',
    businessCountry: '',
    businessBuildingNumber: '',
    businessCity: '',
    businessPostCode: '',
    businessStreet: '',
  },
  isPlaceOfBusinessSame: false,
  selectedPayconstructProducts: {},
  selectedPaymeroProducts: {},
  isProductsFetched: false,
  customerDetails: {},
  gamblingCountries: [
    { name: 'EEA Countries' },
    { label: 'EU Countries', text: 'EU Countries', flag: true },
  ],
  forexCountries: [
    { label: 'United Kingdom' },
    { label: 'EU Contries', text: 'EU Countries', flag: true },
    { label: 'United States' },
    { label: 'Switzerland' },
  ],
  commonCountries: [{ name: 'EEA Countries' }, { name: 'EU Countries' }],

  // regulatoryDetails
  industries: [],
  selectedIndustryForex: [],
  selectedIndustryGaming: [],
  selectedForexOther: '',
  selectedGamingOther: '',
  selectedIndustryOther: '',

  subjectToRegulatoryEnforcement: undefined,
  regulatoryDetails: {},
  signupFormData: [],
  loginFormData: [],
  resetPassFormData: [],

  regulatoryRiskDetails: {
    licenseType: '',
    transactionMonitor: Boolean,
    regulatedCountry: [],
    licenseHolderName: '',
    amlPolicyShared: Boolean,
    amlPolicyComment: '',
    isOperatingInRiskCountries: Boolean,
    subjectToRegulatoryEnforcement: Boolean,
    depositingBank: '',
    settlingBank: '',
    flowOfFundsComment: '',
    reasonForUsingOurServices: '',
    majorityClientBase: '',
    majorityClientJurisdiction: [],
  },
  // new
  regulatoryQuestions: [],
  nextQuestionToAsk: {},
  nextQuestionToAsks: [],
  nextRegulatoryQuestionId: '',
  licenseType: [],
  selectedLicenseType: '',

  progressLogs: {
    isCompanyInformationDone: false,
    isCompanyRequirementsDone: false,
    isOperationInformationDone: false,
    isRegulatoryInformationDone: false,
    isDocumentsUploadedDone: false,
  },

  operationQuestions: {},
  selectedOperationsQuestions: {},

  isRegulatoryInfoEditOrView: false,
  // countries
  // EEACountries: [],
  // EUCountries: [],
  isGamingCountriesFetched: true,
  isForexCountriesFetched: true,
  gamingACountries: [],
  forexACountries: [],
  countriesListBasedOnIndustryType: [],

  overAllRiskCategory: '',

  // company documents and questions

  currentUploadedFile: {},
  currentFileName: {},
  // uploadedDocumentFiles: [],
  // initialselectedDocumentFiles: [],
  selectedDocumentFiles: [],
  uploadedDocumentsQuestions: {},
  selectedDocumentQuestions: {},

  // ubos and directors

  isAddStakeholderEnabled: false,
  isEditStakeholderEnabled: false,
  selectedUBORecord: {},
  people: [],
  currentModule: '',
  totalSharePercentageAdded: 0,

  // RC operation questions

  isAddRCOQBeneEnabled: true,
  isEditRCOQBeneEnabled: false,
  selectedRCOQBeneRecord: {},
  opsRCDetails: [],
  opsCADetails: {},

  isAddRCMarketsEnabled: true,
  isEditRCMarketsEnabled: false,
  selectedRCMarketsRecord: {},
  rcMarketsDetails: [],

  rcMarketsLiveDetails: [],

  // license
  isAddLicenseEnabled: false,
  isEditLicenseEnabled: false,
  selectedLicenseRecord: {},
  licenseDetails: [],
  viewLicenseDetails: [],

  // book a meeting
  meetingUrl: '',
}

export default function registerReducer(state = initialState, action) {
  switch (action.type) {
    case actions.UPDATE_PASSWORD_STRENGTH:
      return {
        ...state,
        passwordStrength: action.value.passwordStrength,
        passwordPercentage: action.value.passwordPercentage,
        progressLogColor: action.value.progressLogColor,
        password: action.value.password,
      }
    case actions.SHOW_CHANGE_PASSWORD_MODAL:
      return {
        ...state,
        modalVisible: true,
      }
    case actions.CLOSE_CHANGE_PASSWORD_MODAL:
      return {
        ...state,
        modalVisible: false,
      }
    case actions.GET_PAYCONSTRUCT_PRODUCTS:
      return {
        ...state,
        loading: true,
      }
    case actions.GET_PAYCONSTRUCT_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        payconstructProducts: action.value,
        isProductsFetched: !state.isProductsFetched,
      }
    case actions.GET_PAYCONSTRUCT_PRODUCTS_FAILURE:
      return {
        ...state,
        loading: false,
      }
    case actions.GET_PAYMERO_PRODUCTS:
      return {
        ...state,
        loading: true,
      }
    case actions.GET_PAYMERO_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        paymeroProducts: action.value,
        isProductsFetched: !state.isProductsFetched,
      }
    case actions.GET_PAYMERO_PRODUCTS_FAILURE:
      return {
        ...state,
        loading: false,
      }
    case actions.UPDATE_PREFFERED_COMMUICATION_LIST:
      return {
        ...state,
        preferredCommunications: action.payload,
      }
    case actions.UPDATE_PREQUALIFICATION_DETAILS:
      return {
        ...state,
        preQualification: action.payload,
      }
    // case actions.SELECTED_PAYCONSTRUCT_PRODUCTS:
    //   return {
    //     ...state,
    //     selectedPayconstructProducts: action.payload,
    //   }
    case actions.SELECTED_PAYMERO_PRODUCTS:
      return {
        ...state,
        selectedPaymeroProducts: action.payload,
      }
    case actions.UPDATE_CUSTOMER_DETAILS:
      return {
        ...state,
        loading: true,
        currentModule: action.module,
      }

    case actions.GET_CUSTOMER_DETAILS_SUCCESS: {
      const selectedProducts = {}
      if (action.value.brands.length > 0) {
        action.value.brands[0].products.map(item => {
          Object.entries(item).forEach(([key]) => {
            if (key === 'product') selectedProducts[item.product] = true
          })
          return selectedProducts
        })
      }
      return {
        ...state,
        selectedPayconstructProducts: selectedProducts,
      }
    }

    case actions.UPDATE_CUSTOMER_DETAILS_SUCCESS: {
      // const selectedProducts = {}
      let forexGroup = []
      let gamingGroup = []
      let forexOther = ''
      let gamingOther = ''
      let other = ''
      let companyAddress = {}
      let principleAddress = {}
      // if (action.value.brands.length > 0) {
      //   action.value.brands[0].products.map(item => {
      //     Object.entries(item).forEach(([key]) => {
      //       if (key === 'product') selectedProducts[item.product] = true
      //     })
      //     return selectedProducts
      //   })
      // }
      if (
        action.value.genericInformation.industries !== undefined &&
        action.value.genericInformation.industries.length > 0
      ) {
        action.value.genericInformation.industries.forEach(element => {
          if (element.industryType === 'forex') forexGroup = element.subType
          if (element.industryType === 'forex' && element.comment) forexOther = element.comment
          if (element.industryType === 'gambling') gamingGroup = element.subType
          if (element.industryType === 'gambling' && element.comment) gamingOther = element.comment
          if (element.industryType === 'other' && element.comment) other = element.comment
        })
      }
      if (
        action.value.genericInformation.addresses !== undefined &&
        action.value.genericInformation.addresses !== null &&
        action.value.genericInformation.addresses.length > 0
      ) {
        action.value.genericInformation.addresses.forEach(element => {
          if (element.type === 'registered') companyAddress = element
          if (element.type === 'principal_place_of_business') {
            principleAddress = element
            state.isPlaceOfBusinessSame = true
          } else state.isPlaceOfBusinessSame = false
        })
      }
      const selectedOperationInfo = {}
      if (
        action.value.operationsDetails !== undefined &&
        Object.entries(action.value.operationsDetails).length > 0
      ) {
        Object.entries(action.value.operationsDetails).forEach(([key, value]) => {
          if (key && value) Object.assign(selectedOperationInfo, value)
        })
      }
      const regulatoryDetails =
        action.value.regulatoryDetails !== undefined &&
        Object.entries(action.value.regulatoryDetails).length > 0 &&
        action.value.regulatoryDetails
      const isRegulatInfoShouldBeEditOrView =
        action.value.regulatoryDetails !== undefined &&
        action.value.regulatoryDetails.licenseType &&
        action.value.regulatoryDetails.regulatedCountries.length > 0

      const statusLogs = action.value && action.value.progressLogs

      const stakeholders =
        action.value.people !== undefined && action.value.people.length > 0
          ? action.value.people
          : state.people

      const selectedDocumentQuestionsInfo = {}

      if (
        action.value.additionalDetails !== undefined &&
        Object.entries(action.value.additionalDetails).length > 0
      ) {
        Object.entries(action.value.additionalDetails).forEach(([key, value]) => {
          if (key && value) selectedDocumentQuestionsInfo[key] = value
        })
      }

      return {
        ...state,
        loading: false,
        overAllKycStatus: action.value.kycInformation.kycStatus,
        industries:
          action.value.genericInformation.industries !== undefined &&
          action.value.genericInformation.industries.length > 0
            ? action.value.genericInformation.industries
            : [],
        licenseDetails: regulatoryDetails.licenses,
        viewLicenseDetails: regulatoryDetails.licenses,
        regulatoryRiskDetails: {
          licenseType: regulatoryDetails.licenseType
            ? regulatoryDetails.licenseType
            : state.regulatoryRiskDetails.licenseType,
          amlPolicyShared: regulatoryDetails.amlPolicyDetails
            ? regulatoryDetails.amlPolicyDetails.amlPolicyShared
            : state.amlPolicyShared,
          amlPolicyComment:
            regulatoryDetails.amlPolicyDetails !== undefined && regulatoryDetails.amlPolicyDetails
              ? regulatoryDetails.amlPolicyDetails.comments
              : state.regulatoryRiskDetails.amlPolicyComment,

          isOperatingInRiskCountries: regulatoryDetails.isOperatingInRiskCountries,
          subjectToRegulatoryEnforcement: regulatoryDetails.subjectToRegulatoryEnforcement,
          transactionMonitor: regulatoryDetails.transactionMonitor,
          licenseHolderName:
            regulatoryDetails.licenseHolderName !== undefined &&
            regulatoryDetails.licenseHolderName &&
            regulatoryDetails.licenseHolderName,
          regulatedCountry: regulatoryDetails.regulatedCountry
            ? regulatoryDetails.regulatedCountry
            : state.regulatoryRiskDetails.regulatedCountry,

          depositingBank: regulatoryDetails.depositingBank,
          settlingBank: regulatoryDetails.settlingBank,
          flowOfFundsComment: regulatoryDetails.flowOfFundsComment,
          reasonForUsingOurServices: regulatoryDetails.reasonForUsingOurServices,
          majorityClientBase: regulatoryDetails.majorityClientBase,
          majorityClientJurisdiction: regulatoryDetails.majorityClientJurisdiction,
        },

        isRegulatoryInfoEditOrView: isRegulatInfoShouldBeEditOrView && false,

        // selectedPayconstructProducts: selectedProducts,

        selectedCompanyInformation: {
          tradingName:
            action.value.genericInformation.tradingName !== undefined
              ? action.value.genericInformation.tradingName
              : action.value.genericInformation.tradingName,
          registeredCompanyName:
            action.value.genericInformation.registeredCompanyName !== undefined
              ? action.value.genericInformation.registeredCompanyName
              : '',
          companyType:
            action.value.genericInformation.companyType !== undefined
              ? action.value.genericInformation.companyType
              : '',
          companyNumber:
            action.value.genericInformation.companyNumber !== undefined
              ? action.value.genericInformation.companyNumber
              : '',

          countryOfIncorportation:
            companyAddress.country !== undefined ? companyAddress.country : '',
          buildingNumber:
            companyAddress.buildingNumber !== undefined ? companyAddress.buildingNumber : '',
          street: companyAddress.street !== undefined ? companyAddress.street : '',
          city: companyAddress.city !== undefined ? companyAddress.city : '',

          floor: companyAddress.floor !== undefined ? companyAddress.floor : '',
          room: companyAddress.room !== undefined ? companyAddress.room : '',
          postBox: companyAddress.postBox !== undefined ? companyAddress.postBox : '',

          businessFloor: principleAddress.floor !== undefined ? principleAddress.floor : '',
          businessRoom: principleAddress.room !== undefined ? principleAddress.room : '',
          businessPostBox: principleAddress.postBox !== undefined ? principleAddress.postBox : '',

          postCode: companyAddress.postCode !== undefined ? companyAddress.postCode : '',
          businessCountry: principleAddress.country !== undefined ? principleAddress.country : '',
          businessBuildingNumber:
            principleAddress.buildingNumber !== undefined ? principleAddress.buildingNumber : '',
          businessCity: principleAddress.city !== undefined ? principleAddress.city : '',
          businessPostCode:
            principleAddress.postCode !== undefined ? principleAddress.postCode : '',
          businessStreet: principleAddress.street !== undefined ? principleAddress.street : '',
          websiteAddress:
            action.value.genericInformation.websiteAddress !== undefined
              ? action.value.genericInformation.websiteAddress
              : '',
        },
        selectedIndustryForex: forexGroup,
        selectedIndustryGaming: gamingGroup,
        selectedForexOther: forexOther,
        selectedGamingOther: gamingOther,
        selectedIndustryOther: other,

        overAllRiskCategory:
          action.value.riskCategory !== undefined
            ? action.value.riskCategory
            : state.overAllRiskCategory,

        selectedOperationsQuestions: selectedOperationInfo,

        opsRCDetails:
          action.value.operationsDetails !== undefined &&
          action.value.operationsDetails.restrictedCurrency !== undefined
            ? action.value.operationsDetails.restrictedCurrency.beneficiaries
            : {},

        rcMarketsDetails:
          action.value.operationsDetails !== undefined &&
          action.value.operationsDetails.restrictedCurrency !== undefined
            ? action.value.operationsDetails.restrictedCurrency.restrictedCurrencyMarkets
            : {},

        opsCADetails:
          action.value.operationsDetails !== undefined &&
          action.value.operationsDetails.currencyAccount !== undefined
            ? action.value.operationsDetails.currencyAccount
            : {},

        selectedDocumentQuestions: selectedDocumentQuestionsInfo,

        progressLogs: {
          isCompanyInformationDone: statusLogs.isCompanyInformationDone,
          isCompanyRequirementsDone: statusLogs.isCompanyRequirementsDone,
          isOperationInformationDone: statusLogs.isOperationInformationDone,
          isRegulatoryInformationDone: statusLogs.isRegulatoryInformationDone,
          isDocumentsUploadedDone: statusLogs.isDocumentsUploadedDone,
        },
        people: stakeholders,
      }
    }
    case actions.UPDATE_CUSTOMER_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
      }

    // case actions.GET_OPERATION_MOCK_DATA:
    //   return {
    //     ...state,
    //     operationFormData: action.payload
    //   }

    // handling input form data's

    case actions.UPDATE_USER_INPUT_DATA_REGISTER:
      return {
        ...state,
        signupFormData: action.payload,
      }
    case actions.UPDATE_USER_INPUT_DATA_LOGIN:
      return {
        ...state,
        loginFormData: action.payload,
      }
    case actions.UPDATE_USER_INPUT_DATA_RESET_PASSWORD:
      return {
        ...state,
        resetPassFormData: action.payload,
      }
    case actions.LOCATION_CHANGE:
      return {
        ...state,
        signupFormData: action.payload.isFirstRendering ? {} : state.signupFormData,
        loginFormData: action.payload.isFirstRendering ? {} : state.loginFormData,
        resetPassFormData: action.payload.isFirstRendering ? {} : state.resetPassFormData,
      }

    // user info

    case userActions.GET_USER_DATA_SUCCESS: {
      const validationOnEntity = action.value.entity !== undefined
      const selectedProducts = {}
      let forexGroup = []
      let gamingGroup = []
      let forexOther = ''
      let gamingOther = ''
      let other = ''
      let companyAddress = {}
      let principleAddress = {}
      if (action.value.entity.brands !== undefined && action.value.entity.brands.length > 0) {
        action.value.entity.brands[0].products.map(item => {
          Object.entries(item).forEach(([key]) => {
            if (key === 'product') selectedProducts[item.product] = true
          })
          return selectedProducts
        })
      }
      if (
        validationOnEntity &&
        action.value.entity.genericInformation.industries !== undefined &&
        action.value.entity.genericInformation.industries.length > 0
      ) {
        action.value.entity.genericInformation.industries.forEach(element => {
          if (element.industryType === 'forex') forexGroup = element.subType
          if (element.industryType === 'forex' && element.comment) forexOther = element.comment
          if (element.industryType === 'gambling') gamingGroup = element.subType
          if (element.industryType === 'gambling' && element.comment) gamingOther = element.comment
          if (element.industryType === 'other' && element.comment) other = element.comment
        })
      }
      if (
        validationOnEntity &&
        action.value.entity.genericInformation.addresses !== undefined &&
        action.value.entity.genericInformation.addresses !== null &&
        action.value.entity.genericInformation.addresses.length > 0
      ) {
        action.value.entity.genericInformation.addresses.forEach(element => {
          if (element.type === 'registered') companyAddress = element
          if (element.type === 'principal_place_of_business') {
            principleAddress = element
            state.isPlaceOfBusinessSame = true
          }
        })
      }
      const selectedOperationInfo = {}
      if (
        validationOnEntity &&
        action.value.entity.operationsDetails !== undefined &&
        Object.entries(action.value.entity.operationsDetails).length > 0
      ) {
        Object.entries(action.value.entity.operationsDetails).forEach(([key, value]) => {
          if (key && value) Object.assign(selectedOperationInfo, value)
        })
      }
      const regulatoryDetails =
        validationOnEntity &&
        action.value.entity.regulatoryDetails !== undefined &&
        Object.entries(action.value.entity.regulatoryDetails).length > 0 &&
        action.value.entity.regulatoryDetails

      const isRegulatInfoShouldBeEditOrView =
        validationOnEntity &&
        action.value.entity.regulatoryDetails !== undefined &&
        action.value.entity.regulatoryDetails.licenseType &&
        action.value.entity.regulatoryDetails.regulatedCountries.length > 0

      const statusLogs =
        validationOnEntity &&
        action.value.entity.progressLogs !== undefined &&
        action.value.entity.progressLogs

      const stakeholders =
        validationOnEntity &&
        action.value.entity.people !== undefined &&
        action.value.entity.people.length > 0
          ? action.value.entity.people
          : state.people
      const selectedDocumentQuestionsInfo = {}
      if (
        validationOnEntity &&
        action.value.entity.additionalDetails !== undefined &&
        Object.entries(action.value.entity.additionalDetails).length > 0
      ) {
        Object.entries(action.value.entity.additionalDetails).forEach(([key, value]) => {
          if (key && value) selectedDocumentQuestionsInfo[key] = value
        })
      }

      return {
        ...state,
        overAllKycStatus: action.value.entity.kycInformation.kycStatus,
        industries:
          action.value.entity.genericInformation.industries !== undefined &&
          action.value.entity.genericInformation.industries.length > 0
            ? action.value.entity.genericInformation.industries
            : [],
        customerDetails: action.value.entity,

        licenseDetails: regulatoryDetails.licenses,
        viewLicenseDetails: regulatoryDetails.licenses,
        regulatoryRiskDetails: {
          licenseType: regulatoryDetails.licenseType
            ? regulatoryDetails.licenseType
            : state.regulatoryRiskDetails.licenseType,
          amlPolicyShared: regulatoryDetails.amlPolicyDetails
            ? regulatoryDetails.amlPolicyDetails.amlPolicyShared
            : state.amlPolicyShared,
          amlPolicyComment:
            regulatoryDetails.amlPolicyDetails !== undefined && regulatoryDetails.amlPolicyDetails
              ? regulatoryDetails.amlPolicyDetails.comments
              : state.regulatoryRiskDetails.amlPolicyComment,

          isOperatingInRiskCountries: regulatoryDetails.isOperatingInRiskCountries,
          subjectToRegulatoryEnforcement: regulatoryDetails.subjectToRegulatoryEnforcement,
          transactionMonitor: regulatoryDetails.transactionMonitor,
          licenseHolderName:
            regulatoryDetails.licenseHolderName !== undefined &&
            regulatoryDetails.licenseHolderName &&
            regulatoryDetails.licenseHolderName,
          regulatedCountry: regulatoryDetails.regulatedCountry
            ? regulatoryDetails.regulatedCountry
            : state.regulatoryRiskDetails.regulatedCountry,

          depositingBank: regulatoryDetails.depositingBank,
          settlingBank: regulatoryDetails.settlingBank,
          flowOfFundsComment: regulatoryDetails.flowOfFundsComment,
          reasonForUsingOurServices: regulatoryDetails.reasonForUsingOurServices,
          majorityClientBase: regulatoryDetails.majorityClientBase,
          majorityClientJurisdiction: regulatoryDetails.majorityClientJurisdiction,
        },

        isRegulatoryInfoEditOrView: isRegulatInfoShouldBeEditOrView
          ? state.isRegulatoryInfoEditOrView
          : isRegulatInfoShouldBeEditOrView,

        selectedPayconstructProducts: selectedProducts,

        selectedCompanyInformation: {
          tradingName:
            action.value.entity.genericInformation.tradingName !== undefined
              ? action.value.entity.genericInformation.tradingName
              : action.value.entity.genericInformation.tradingName,
          registeredCompanyName:
            action.value.entity.genericInformation.registeredCompanyName !== undefined
              ? action.value.entity.genericInformation.registeredCompanyName
              : state.selectedCompanyInformation.registeredCompanyName,
          companyType:
            action.value.entity.genericInformation.companyType !== undefined
              ? action.value.entity.genericInformation.companyType
              : '',
          companyNumber:
            action.value.entity.genericInformation.companyNumber !== undefined
              ? action.value.entity.genericInformation.companyNumber
              : state.selectedCompanyInformation.companyNumber,

          countryOfIncorportation:
            companyAddress.country !== undefined ? companyAddress.country : '',
          buildingNumber:
            companyAddress.buildingNumber !== undefined ? companyAddress.buildingNumber : '',
          street: companyAddress.street !== undefined ? companyAddress.street : '',
          city: companyAddress.city !== undefined ? companyAddress.city : '',
          postCode: companyAddress.postCode !== undefined ? companyAddress.postCode : '',

          floor: companyAddress.floor !== undefined ? companyAddress.floor : '',
          room: companyAddress.room !== undefined ? companyAddress.room : '',
          postBox: companyAddress.postBox !== undefined ? companyAddress.postBox : '',

          businessFloor: principleAddress.floor !== undefined ? principleAddress.floor : '',
          businessRoom: principleAddress.room !== undefined ? principleAddress.room : '',
          businessPostBox: principleAddress.postBox !== undefined ? principleAddress.postBox : '',

          businessCountry: principleAddress.country !== undefined ? principleAddress.country : '',
          businessBuildingNumber:
            principleAddress.buildingNumber !== undefined ? principleAddress.buildingNumber : '',
          businessCity: principleAddress.city !== undefined ? principleAddress.city : '',
          businessPostCode:
            principleAddress.postCode !== undefined ? principleAddress.postCode : '',
          businessStreet: principleAddress.street !== undefined ? principleAddress.street : '',
          websiteAddress:
            action.value.entity.genericInformation.websiteAddress !== undefined &&
            action.value.entity.genericInformation.websiteAddress,
        },

        selectedIndustryForex: forexGroup,
        selectedIndustryGaming: gamingGroup,
        selectedForexOther: forexOther,
        selectedGamingOther: gamingOther,
        selectedIndustryOther: other,

        overAllRiskCategory:
          action.value.entity.riskCategory !== undefined
            ? action.value.entity.riskCategory
            : state.overAllRiskCategory,

        selectedOperationsQuestions: selectedOperationInfo,

        selectedDocumentQuestions: selectedDocumentQuestionsInfo,

        opsRCDetails:
          action.value.entity.operationsDetails !== undefined &&
          action.value.entity.operationsDetails.restrictedCurrency !== undefined
            ? action.value.entity.operationsDetails.restrictedCurrency.beneficiaries
            : {},

        rcMarketsDetails:
          action.value.entity.operationsDetails !== undefined &&
          action.value.entity.operationsDetails.restrictedCurrency !== undefined
            ? action.value.entity.operationsDetails.restrictedCurrency.restrictedCurrencyMarkets
            : {},

        opsCADetails:
          action.value.entity.operationsDetails !== undefined &&
          action.value.entity.operationsDetails.currencyAccount !== undefined
            ? action.value.entity.operationsDetails.currencyAccount
            : {},

        progressLogs: {
          isCompanyInformationDone: statusLogs.isCompanyInformationDone,
          isCompanyRequirementsDone: statusLogs.isCompanyRequirementsDone,
          isOperationInformationDone: statusLogs.isOperationInformationDone,
          isRegulatoryInformationDone: statusLogs.isRegulatoryInformationDone,
          isDocumentsUploadedDone: statusLogs.isDocumentsUploadedDone,
        },
        people: stakeholders,
      }
    }

    // risk qualification

    case actions.UPDATE_REGULATORY_DETAILS: {
      const getPropertyValue = (data, value, isValueExist, stateValue) => {
        let returnResp
        if (Object.prototype.hasOwnProperty.call(data, value)) {
          returnResp = isValueExist
        } else {
          returnResp = stateValue
        }
        return returnResp
      }
      return {
        ...state,
        ...action.values,
        ...state.regulatoryDetails,
        isRegulated: getPropertyValue(
          action.values,
          'isRegulated',
          action.values.isRegulated,
          state.isRegulated,
        ),
        havePendingLicense: getPropertyValue(
          action.values,
          'havePendingLicense',
          action.values.havePendingLicense,
          state.havePendingLicense,
        ),
        holdSubLicense: getPropertyValue(
          action.values,
          'holdSubLicense',
          action.values.holdSubLicense,
          state.holdSubLicense,
        ),
        licenseHolderName: getPropertyValue(
          action.values,
          'licenseHolderName',
          action.values.licenseHolderName,
          state.licenseHolderName,
        ),
        subjectToRegulatoryEnforcement: getPropertyValue(
          action.values,
          'subjectToRegulatoryEnforcement',
          action.values.subjectToRegulatoryEnforcement,
          state.subjectToRegulatoryEnforcement,
        ),
        regulatoryDetails: Object.assign(state.regulatoryDetails, action.values),
      }
    }

    case actions.GET_OPERATION_QUESTIONS: {
      return {
        ...state,
        loading: true,
      }
    }
    case actions.GET_OPERATION_QUESTIONS_SUCCESS: {
      return {
        ...state,
        loading: false,
        operationQuestions: action.value,
      }
    }
    case actions.GET_OPERATION_QUESTIONS_FAILURE: {
      return {
        ...state,
        loading: false,
        operationQuestions: action.value,
      }
    }
    case actions.GET_REGULATORY_QUESTIONS_SUCCESS: {
      const regulatoryLicenseType = []
      action.value.question[0].conditions.forEach(type => {
        const formatData = {
          label: type.rule[0],
          text: type.rule[0],
        }
        regulatoryLicenseType.push(formatData)
      })
      return {
        ...state,
        regulatoryQuestions: action.value.question,
        licenseType: regulatoryLicenseType,
      }
    }
    case actions.GET_NEXT_REGULATORY_QUESTION_SUCCESS:
      return {
        ...state,
        nextQuestionToAsk: action.value,
        nextQuestionToAsks: [...state.nextQuestionToAsks, action.value],
        nextRegulatoryQuestionId: action.value !== null && action.value.id,
      }
    case actions.UPDATE_SELECTED_LICENSE_TYPE:
      return {
        ...state,
        selectedLicenseType: action.value,
      }

    // case actions.GET_REGULATORY_COUNTRIES_SUCCESS:
    //   return {
    //     ...state,
    //     EEACountries: action.value,
    //   }
    // case actions.GET_EU_COUNTRIES_SUCCESS:
    //   return {
    //     ...state,
    //     EUCountries: action.value,
    //   }

    case actions.GET_GAMING_COUNTRIES_SUCCESS:
      return {
        ...state,
        isGamingCountriesFetched: !state.isGamingCountriesFetched,
        gamingACountries: action.value,
      }
    case actions.GET_FOREX_COUNTRIES_SUCCESS:
      return {
        ...state,
        isForexCountriesFetched: !state.isForexCountriesFetched,
        forexACountries: action.value,
      }
    case actions.UPDATE_COUNTRIESLIST_BASED_ON_INDUSTRY_SELECT:
      return {
        ...state,
        countriesListBasedOnIndustryType: action.payload,
      }
    case actions.IS_EDIT_VIEW_REGULATORY_INFO_UPDATED:
      return {
        ...state,
        isRegulatoryInfoEditOrView: action.payload,
      }

    // Upload Document Files and Questions
    case actions.GET_DOCUMENTS_FILE: {
      return {
        ...state,
        loading: true,
      }
    }
    case actions.GET_DOCUMENTS_FILE_SUCCESS: {
      const allFiles = action.value !== undefined && action.value.length > 0 ? action.value : []
      allFiles.forEach(file => {
        Object.assign(file, { name: file.fileName })
        delete file.fileName
      })
      return {
        ...state,
        selectedDocumentFiles: action.value,
        loading: false,
      }
    }
    case actions.GET_DOCUMENTS_FILE_FAILURE: {
      return {
        ...state,
        loading: false,
      }
    }
    case actions.GET_PRESIGNED_URL: {
      return {
        ...state,
        loading: true,
        currentUploadedFile: action.payload.data,
      }
    }
    case actions.GET_PRESIGNED_URL_SUCCESS: {
      const selectedFiles = Object.assign(state.currentUploadedFile, action.value)
      return {
        ...state,
        loading: false,
        selectedDocumentFiles: [...state.selectedDocumentFiles, selectedFiles],
      }
    }
    case actions.GET_PRESIGNED_URL_FAILURE: {
      // const filterData = state.selectedDocumentFiles.filter(
      //   item => item.uid !== state.currentUploadedFile.uid,
      // )
      return {
        ...state,
        loading: false,
        // selectedDocumentFiles: filterData,
      }
    }
    case actions.ADD_DOCUMENT_FILES: {
      return {
        ...state,
        loading: true,
      }
    }
    case actions.ADD_DOCUMENT_FILES_FAILURE: {
      // const filterData = state.selectedDocumentFiles.filter(
      //   item => item.uid !== state.currentUploadedFile.uid,
      // )
      return {
        ...state,
        // selectedDocumentFiles: filterData,
        loading: false,
      }
    }
    case actions.ADD_DOCUMENT_FILES_SUCCESS: {
      return {
        ...state,
        loading: false,
      }
    }
    case actions.REMOVE_DOCUMENT_FILES: {
      const filterData = state.selectedDocumentFiles.filter(item => item.uid !== action.payload.uid)
      return {
        ...state,
        loading: true,
        selectedDocumentFiles: filterData,
      }
    }
    case actions.REMOVE_DOCUMENT_FILES_SUCCESS: {
      return {
        ...state,
        loading: false,
      }
    }
    case actions.REMOVE_DOCUMENT_FILES_FAILURE: {
      return {
        ...state,
        loading: false,
      }
    }
    case actions.GET_DOCUMENTS_QUESTIONS: {
      return {
        ...state,
        loading: true,
      }
    }
    case actions.GET_DOCUMENTS_QUESTIONS_SUCCESS: {
      return {
        ...state,
        uploadedDocumentsQuestions: action.value,
        loading: false,
      }
    }
    case actions.GET_DOCUMENTS_QUESTIONS_FAILURE: {
      return {
        ...state,
        loading: false,
      }
    }
    // ubos and directors

    case actions.ADD_UBO_DETAILS: {
      return {
        ...state,
        isAddStakeholderEnabled: action.payload,
      }
    }
    case actions.CANCEL_UBO_DETAILS: {
      return {
        ...state,
        isAddStakeholderEnabled: action.payload,
        isEditStakeholderEnabled: action.payload,
      }
    }
    case actions.UPDATE_UBO_DETAILS: {
      return {
        ...state,
        people: [...state.people, action.payload],
      }
    }
    case actions.DELETE_SELECTED_UBO: {
      return {
        ...state,
        people: action.payload,
      }
    }
    case actions.UPDATE_SELECTED_EDIT_UBO: {
      return {
        ...state,
        isEditStakeholderEnabled: action.payload.isEditStakeholderEnabled,
        selectedUBORecord: action.payload.selectedRecord,
        totalSharePercentageAdded:
          action.payload.selectedRecord.percentageOfShares !== undefined
            ? state.totalSharePercentageAdded - action.payload.selectedRecord.percentageOfShares
            : state.totalSharePercentageAdded,
      }
    }
    // end

    // people

    case actions.GET_ALL_STAKEHOLDERS: {
      return {
        ...state,
        loading: true,
      }
    }
    case actions.GET_ALL_STAKEHOLDERS_SUCCESS: {
      let arrSum
      const addedSharePercenatge = []
      if (action.value.people !== undefined && action.value.people.length > 0) {
        action.value.people.forEach(element => {
          const checkNumber = element.percentageOfShares ? element.percentageOfShares : 0
          addedSharePercenatge.push(parseFloat(checkNumber))
        })
        arrSum = addedSharePercenatge.reduce((a, b) => a + b, 0)
      } else {
        arrSum = 0
      }
      return {
        ...state,
        loading: false,
        totalSharePercentageAdded: arrSum,
        people: action.value.people,
      }
    }
    case actions.GET_ALL_STAKEHOLDERS_FAILURE: {
      return {
        ...state,
        loading: false,
      }
    }

    case actions.ADD_COMPANY_STAKEHOLDER: {
      return {
        ...state,
        loading: true,
      }
    }
    case actions.ADD_COMPANY_STAKEHOLDER_SUCCESS: {
      return {
        ...state,
        loading: false,
      }
    }
    case actions.ADD_COMPANY_STAKEHOLDER_FAILURE: {
      return {
        ...state,
        loading: false,
      }
    }

    case actions.EDIT_COMPANY_STAKEHOLDER: {
      return {
        ...state,
        loading: true,
      }
    }
    case actions.EDIT_COMPANY_STAKEHOLDER_SUCCESS: {
      return {
        ...state,
        loading: false,
      }
    }
    case actions.EDIT_COMPANY_STAKEHOLDER_FAILURE: {
      return {
        ...state,
        loading: false,
      }
    }

    case actions.DELETE_COMPANY_STAKEHOLDER: {
      return {
        ...state,
        loading: true,
      }
    }
    case actions.DELETE_COMPANY_STAKEHOLDER_SUCCESS: {
      return {
        ...state,
        loading: false,
      }
    }
    case actions.DELETE_COMPANY_STAKEHOLDER_FAILURE: {
      return {
        ...state,
        loading: false,
      }
    }

    case actions.UPDATE_TOTAL_PERCENTAGESHARES: {
      return {
        ...state,
        totalSharePercentageAdded: action.value,
      }
    }

    // end

    // RC operation questions

    case actions.ADD_RC_OQ_BENE_DETAILS: {
      return {
        ...state,
        isAddRCOQBeneEnabled: action.payload,
        isEditRCOQBeneEnabled: false,
      }
    }
    case actions.CANCEL_RC_OQ_BENE_DETAILS: {
      return {
        ...state,
        isAddRCOQBeneEnabled: false,
        isEditRCOQBeneEnabled: false,
      }
    }
    case actions.EDIT_RC_OQ_BENE_DETAILS: {
      return {
        ...state,
        isAddRCOQBeneEnabled: false,
        selectedRCOQBeneRecord: action.payload.record,
        isEditRCOQBeneEnabled: action.payload.isEnable,
      }
    }
    case actions.UPDATE_RC_OQ_BENE_DETAILS: {
      return {
        ...state,
        opsRCDetails: [...state.opsRCDetails, action.payload],
      }
    }
    case actions.DELETE_SELECTED_RC_OQ_BENE: {
      return {
        ...state,
        opsRCDetails: action.payload,
      }
    }

    // RC restricted currencies operation questions

    case actions.ADD_RC_RM_DETAILS: {
      return {
        ...state,
        isAddRCMarketsEnabled: action.payload,
        isEditRCMarketsEnabled: false,
      }
    }
    case actions.CANCEL_RC_RM_DETAILS: {
      return {
        ...state,
        isAddRCMarketsEnabled: false,
        isEditRCMarketsEnabled: false,
      }
    }
    case actions.EDIT_RC_RM_DETAILS: {
      return {
        ...state,
        isAddRCMarketsEnabled: false,
        selectedRCMarketsRecord: action.payload.record,
        isEditRCMarketsEnabled: action.payload.isEnable,
      }
    }
    case actions.UPDATE_RC_RM_DETAILS: {
      return {
        ...state,
        rcMarketsDetails: [...state.rcMarketsDetails, action.payload],
      }
    }
    case actions.DELETE_SELECTED_RC_RM: {
      return {
        ...state,
        rcMarketsDetails: action.payload,
      }
    }

    // book a meeting

    case actions.OPEN_MODAL_BOOK_A_MEETING: {
      return {
        ...state,
        bookaMeetingModal: action.payload,
        meetingUrl: action.bookMeetingUrl,
      }
    }
    case actions.CLOSE_MODAL_BOOK_A_MEETING: {
      return {
        ...state,
        bookaMeetingModal: action.payload,
      }
    }

    // license

    case actions.ADD_LICENSE: {
      return {
        ...state,
        isAddLicenseEnabled: action.payload,
        isEditLicenseEnabled: false,
      }
    }
    case actions.CANCEL_LICENSE: {
      return {
        ...state,
        isAddLicenseEnabled: false,
        isEditLicenseEnabled: false,
      }
    }
    case actions.EDIT_LICENSE: {
      return {
        ...state,
        isAddLicenseEnabled: false,
        selectedLicenseRecord: action.payload.record,
        isEditLicenseEnabled: action.payload.isEnable,
      }
    }
    case actions.UPDATE_LICENSE: {
      return {
        ...state,
        licenseDetails: [...state.licenseDetails, action.payload],
      }
    }
    case actions.DELETE_LICENSE: {
      return {
        ...state,
        licenseDetails: action.payload,
      }
    }

    case actions.UPDATE_RC_MARKETS_LIVE: {
      return {
        ...state,
        rcMarketsLiveDetails: action.payload,
      }
    }
    default:
      return state
  }
}
